module.exports = __webpack_public_path__ + "static/img/logo_udian.7ae7d03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_udian.png
// module id = 0zkr
// module chunks = 51